import zh_CN from './zh_CN';
import en_US from './en_US';

export { zh_CN, en_US };



// WEBPACK FOOTER //
// ./src/locales/index.js